<template>
<div class="row">
 <div class="col-md-10 d-flex align-items-start">
    <div class="container">
        <div class="d-flex justify-content-center mb-3">
            <div class="card p-2 shadow rounded">
            <div class="fw-bold dashboard-label fs-4">Work Flow</div>
            </div>
        </div>
        <div class="sitemap-grid">
            <div class="left-rail"></div>
            <div class="rows">
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-home me-2 text-primary"></i>Dashboard</div>
                    <ul class="submenu  submenu-a">
                        <li><i class="fas fa-user-graduate  me-2 text-primary"></i>Student</li>
                        <li><i class="fas fa-chalkboard-teacher me-2 text-primary"></i>Teacher</li>
                        <li><i class="fas fa-users me-2 text-primary"></i>Staff</li>
                        <li><i class="far fa-newspaper me-2 text-primary"></i>News</li>
                        <li><i class="fas fa-birthday-cake me-2 text-primary"></i>Birthday (Print,Download)</li>
                        <li><i class="fas fa-umbrella-beach me-2 text-primary"></i>Holiday (View All)</li>
                        <li><i class="fa fa-magic me-2 text-primary"></i>Festival (Print,Download)</li>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-user me-2 text-primary"></i>Student</div>
                    <ul class="submenu submenu-a">
                        <router-link :to="`/students`" class="text-dark link-primary"><li><i class="fas fa-user-tie me-2 text-primary"></i>Student list  (Add,View,Edit,Delete)</li></router-link>
                         <router-link :to="`/parent`" class="text-dark link-primary"><li><i class="fas fa-user me-2 text-primary"></i>Parent list (View)</li></router-link>
                         <router-link :to="`/export`" class="text-dark link-primary"><li><i class="fas fa-user-plus me-2 text-primary"></i>Export student</li></router-link>
                         <router-link :to="`/promote`" class="text-dark link-primary"><li><i class="fab fa-sellsy me-2 text-primary"></i>Promote student (Edit,Delete)</li></router-link>
                         <router-link :to="`/sscpass`" class="text-dark link-primary"><li><i class="fas fa-user-graduate me-2 text-primary"></i>SSC pass</li></router-link>
                         <router-link :to="`/idcard`" class="text-dark link-primary"><li><i class="fas fa-id-card-alt me-2 text-primary"></i>ID card (Print,Download)</li></router-link>
                         <router-link :to="`/hallticket`" class="text-dark link-primary"><li><i class="fas fa-address-card me-2 text-primary"></i>Hall ticket (Print,Download)</li></router-link>
                         <router-link :to="`/birthday`" class="text-dark link-primary"><li><i class="fas fa-birthday-cake me-2 text-primary"></i>Birthday (Edit,Delete)</li></router-link>
                         <router-link :to="`/booklist`" class="text-dark link-primary"><li><i class="fas fa-book me-2 text-primary"></i>Book list (Edit,Delete)</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-chalkboard-teacher me-2 text-primary"></i>Teacher</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/teachers`" class="text-dark link-primary"><li><i class="fas fa-chalkboard-teacher me-2 text-primary"></i>Teacher list (Add,View,Edit,Delete)</li></router-link>
                         <router-link :to="`/teacheridcard`" class="text-dark link-primary"><li><i class="fas fa-id-card me-2 text-primary"></i>Teacher ID (Print,Download)</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-book me-2 text-primary"></i>Academics</div>
                    <ul class="submenu submenu-a">
                        <router-link :to="`/cls`" class="text-dark link-primary"> <li><i class="fas fa-chalkboard me-2 text-primary"></i>Class (Edit,Delete)</li></router-link>
                         <router-link :to="`/subject`" class="text-dark link-primary"><li><i class="fas fa-book-open me-2 text-primary"></i>Subject (Edit,Delete)</li></router-link>
                         <router-link :to="`/batch`" class="text-dark link-primary"><li><i class="fas fa-users me-2 text-primary"></i>Batch (Edit,Delete)</li></router-link>
                         <router-link :to="`/category`" class="text-dark link-primary"><li><i class="fas fa-tag me-2 text-primary"></i>Category (Edit,Delete)</li></router-link>
                         <router-link :to="`/classtimetable`" class="text-dark link-primary"><li><i class="fas fa-calendar me-2 text-primary "></i>Class timetable (Save,Delete,View All)</li></router-link>
                         <router-link :to="`/attendance`" class="text-dark link-primary"><li><i class="fas fa-calendar-check me-2 text-primary"></i> Attendance (Status update)</li></router-link>
                         <router-link :to="`/homework`" class="text-dark link-primary"><li><i class="fas fa-book me-2 text-primary"></i>Home work (Save,Delete)</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="far fa-calendar-alt me-2 text-primary"></i>Examination</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/examtype`" class="text-dark link-primary"><li><i class="fas fa-paste me-2 text-primary"></i>Exam type (Edit,Delete)</li></router-link>
                         <router-link :to="`/examsetup`" class="text-dark link-primary"><li><i class="fas fa-calendar me-2 text-primary"></i>Exam setup (Edit,Delete)</li></router-link>
                         <router-link :to="`/examtimetable`" class="text-dark link-primary"><li><i class="far fa-calendar-plus me-2 text-primary"></i>Exam timetable (Save,Delete,Print,Download,Gallery)</li></router-link>
                         <router-link :to="`/marks`" class="text-dark link-primary"><li><i class="fas fa-chart-line me-2 text-primary"></i>Marks (Save,Delete,Print,Download,View All)</li></router-link>
                         <router-link :to="`/grade`" class="text-dark link-primary"><li><i class="fas fa-file me-2 text-primary"></i>Grade (Edit,Delete)</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-money-bill-wave me-2 text-primary"></i>Fee Management</div>
                    <ul class="submenu  submenu-a">
                         <router-link :to="`/fee`" class="text-dark link-primary"><li> <i class="fas fa-money-bill-wave me-2 text-primary"></i>Add fee (Edit,Delete)</li></router-link>
                         <router-link :to="`/feesgroup`" class="text-dark link-primary"><li><i class="fas fa-donate me-2 text-primary"></i>Fee group (Edit,Delete)</li></router-link>
                         <router-link :to="`/collect`" class="text-dark link-primary"><li><i class="fas fa-money-check-alt me-2 text-primary"></i>Collect fee (Edit,Delete)</li></router-link>
                         <router-link :to="`/payment`" class="text-dark link-primary"><li><i class="fas fa-file-alt me-2 text-primary"></i>Payment details (View,Edit,Delete)</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-users me-2 text-primary"></i>Staff Management</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/staff`" class="text-dark link-primary"><li><i class="fas fa-users me-2 text-primary"></i>Staff (Edit,Delete)</li></router-link>
                         <router-link :to="`/staffidcard`" class="text-dark link-primary"><li><i class="fas fa-address-card me-2 text-primary"></i>Staff ID (Print,Download)</li></router-link>
                         <router-link :to="`/userlist`" class="text-dark link-primary"><li><i class="fas fa-users me-2 text-primary"></i>User list (Edit,Delete)</li></router-link>
                         <router-link :to="`/applyleave`" class="text-dark link-primary"><li><i class="fas fa-file-text me-2 text-primary"></i>Apply leave (Approval status,Edit,Delete)</li></router-link>
                         <router-link :to="`/appointment`" class="text-dark link-primary"><li><i class="fas fa-clipboard-check me-2 text-primary"></i>Appointment (Edit,Delete)</li></router-link>
                         <router-link :to="`/access`" class="text-dark link-primary"><li><i class="fas fa-shield-alt me-2 text-primary"></i>Access (Read,Create/Update, Delete)</li></router-link>
                         
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-microphone-alt me-2 text-primary"></i>Event &amp; Notice</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/announcement`" class="text-dark link-primary"><li><i class="fas fa-microphone-alt  me-2 text-primary"></i> Announcement (Edit, Delete)</li></router-link>
                         <router-link :to="`/festival`" class="text-dark link-primary"><li><i class="fa fa-magic me-2 text-primary"></i>Festival (Edit,Delete)</li></router-link>
                         <router-link :to="`/holiday`" class="text-dark link-primary"><li><i class="fas fa-umbrella-beach me-2 text-primary"></i>Holiday (Edit,Delete)</li></router-link>
                         <router-link :to="`/news`" class="text-dark link-primary"><li><i class="far fa-newspaper me-2 text-primary"></i>News (Edit,Delete)</li></router-link>
                         <router-link :to="`/banners`" class="text-dark link-primary"><li><i class="fa fa-image me-2 text-primary"></i>Banners (Upload,Download)</li></router-link>
                    </ul>
                </div>
              <div class="row-line">
                    <div class="menu-label"><i class="fas fa-headset me-2 text-primary"></i>Support</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/complaint`" class="text-dark link-primary"><li><i class="fas fa-exclamation-circle me-2 text-primary"></i>Complaint (Edit,Delete)</li></router-link>
                         <router-link :to="`/enquiry`" class="text-dark link-primary"><li><i class="fas fa-phone-volume me-2 text-primary"></i>Enquiry (Edit,Delete)</li></router-link>
                         <router-link :to="`/reminders`" class="text-dark link-primary"><li><i class="fas fa-bell me-2 text-primary"></i>Reminders (Send message)</li></router-link>
                         <router-link :to="`/help`" class="text-dark link-primary"><li><i class="fas fa-phone me-2 text-primary"></i>Help</li></router-link>
                        <router-link :to="`/contactlist`" class="text-dark link-primary"><li><i class="fas fa-address-book me-2 text-primary"></i>Contacts (Edit,Delete)</li></router-link>
                        <router-link :to="`/info`" class="text-dark link-primary"><li><i class="fas fa-file-text-o me-2 text-primary"></i>Info</li></router-link>
                    </ul>
                </div>
                <div class="row-line">
                    <div class="menu-label"><i class="fas fa-file-text me-2 text-primary"></i>Report</div>
                    <ul class="submenu s1 submenu-a">
                         <router-link :to="`/attndreport`" class="text-dark link-primary"><li><i class="fas fa-calendar me-2 text-primary"></i>Attendance Report (Print,Download)</li></router-link>
                         <router-link :to="`/awards`" class="text-dark link-primary"><li><i class="fas fa-award me-2 text-primary"></i>Awards</li></router-link>
                         <router-link :to="`/studentreport`" class="text-dark link-primary"><li><i class="fas fa-user-graduate me-2 text-primary"></i>Student Report</li></router-link>
                          <router-link :to="`/idcardlist`" class="text-dark link-primary"><li><i class="fas fa-id-card me-2 text-primary"></i>Id Card List</li></router-link>
                          <router-link :to="`/bulkfiles`" class="text-dark link-primary"><li><i class="fas fa-file-upload me-2 text-primary"></i>Bulk Files</li></router-link>

                    </ul>
                </div>
             <div class="row-line row-line-a">
                    <div class="menu-label"><i class="fas fa-cogs me-2 text-primary"></i>Others</div>
                    <ul class="submenu submenu-a">
                         <router-link :to="`/transport`" class="text-dark link-primary"><li><i class="fas fa-bus me-2 text-primary"></i>Transport (Edit,Delete)</li></router-link>
                         <router-link :to="`/notifications`" class="text-dark link-primary"><li><i class="fas fa-bell me-2 text-primary"></i>Notifications (Edit,Delete)</li></router-link>
                         <router-link :to="`/generalsetting`" class="text-dark link-primary"><li><i class="fas fa-school me-2 text-primary"></i>General setting</li></router-link>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="col-md-2 d-flex justify-content-end align-items-start">
        <a href="https://us06web.zoom.us/j/89104638462?pwd=ZlFnBLACnwMAv6GxidBZiJqBNHvaWe.1" target="_balnk"><i class="fa fa-video-camera fa-2x  text-primary "></i> </a>
      </div>
    </div>
</template>
<script>
</script>
<style>
.node {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
}
.sitemap-grid {
  display: grid;
  grid-template-columns: 180px 1fr;
  column-gap: 24px;
  margin-left:-150px;
  margin-top:-50px;
}

.left-rail {
  position: relative;
}

.left-rail::after {
  content: "";
  position: absolute;
  top: 46px;
  bottom: 69px;
  right: 0;
  border-right: 2px solid #6c757d;
}

.rows {
  position: relative;
}

.row-line {
  display: grid;
  grid-template-columns: 240px 1fr;
  column-gap: 58px;
  margin: 1.75rem 0;
  position: relative;
}

.row-line::before {
  content: "";
  position: absolute;
  left: -25px;
  top: 1.1rem;
  width: 24px;
  border-top: 2px solid #6c757d;
}

.menu-label {
  font-weight: 600;
  margin-left: 4px;
      margin-top: 7px;
}

.submenu {
  margin: 0;
  padding-left: 1rem;
  list-style: none;
  position: relative;
}

.row-line .submenu::before {
  content: "";
  position: absolute;
      top: 12px;
  left: -8.5rem;
  width: 8.5rem;
  border-top: 2px solid #6c757d;
}
.row-line-a::before{
    top:11px;
}
.submenu::after {
    content: "";
    position: absolute;
    left: -2px;
    top: 15px;
    bottom: 15px;
    width: 2px;
    background: #6c757d;
}


.submenu li {
  margin: 0.25rem 0;
  position: relative;
      margin-left: 8px;
}
.submenu li::before {
  content: "";
  position: absolute;
  left: -25px;       
  top: 0.7rem;         
  width: 1rem;        
  border-top: 2px solid #6c757d;
}
.submenu-a li::before{
    top:0.5rem;
}
</style>